import {
  Rect,
  Circle,
  Triangle,
  Line,
  Polygon,
  Ellipse,
  Path,
  Textbox
} from 'fabric';

function getDefaultProperties() {

  const defaultProperties = {
    fill: 'transparent',
    stroke: 'black',
    strokeWidth: 1,
    strokeUniform: true
  };

  return defaultProperties;

}

const shapeBuilders = {
  rectangle() {
    const rectangle = new Rect({
      ...getDefaultProperties(),
      left: 100,
      top: 100,
      width: 50,
      height: 25
    });
    return rectangle;
  },
  circle() {

    const circle = new Circle({
      ...getDefaultProperties(),
      left: 100,
      top: 100,
      radius: 25
    });

    return circle;

  },
  triangle() {

    const triangle = new Triangle({
      ...getDefaultProperties(),
      left: 100,
      top: 100,
      width: 50,
      height: 50
    });

    return triangle;

  },
  line() {

    const line = new Line([50, 50, 100, 100], {
      ...getDefaultProperties()
    });

    return line;

  },
  polygon() {

    const polygon = new Polygon([
      { x: 50, y: 50 },
      { x: 100, y: 50 },
      { x: 100, y: 100 },
      { x: 50, y: 100 }
    ], {
      ...getDefaultProperties()
    });

    return polygon;

  },
  ellipse() {

    const ellipse = new Ellipse({
      ...getDefaultProperties(),
      left: 100,
      top: 100,
      rx: 25,
      ry: 50
    });

    return ellipse;

  },
  path() {

    const path = new Path('M 0 0 L 100 100', {
      ...getDefaultProperties()
    });

    return path;

  },
  text() {

    const text = new Textbox('Hello World', {
      left: 100,
      top: 100,
      fill: 'black',
      fontSize: 24,
      fontFamily: 'Arial',
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.16,
      charSpacing: 0,
      textAlign: 'left',
      styles: [],
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      minWidth: 20,
      splitByGrapheme: false,
      strokeUniform: true,
      width: 150
    });

    return text;

  }
};

export default shapeBuilders;